/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { DataDairyDto } from "../models";
// @ts-ignore
import { DataListDairyDto } from "../models";
/**
 * DairyApi - axios parameter creator
 * @export
 */
export const DairyApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [regionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllDairies: async (
      regionId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/dairy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (regionId !== undefined) {
        localVarQueryParameter["regionId"] = regionId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDairy: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("getDairy", "id", id);
      const localVarPath = `/dairy/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DairyApi - functional programming interface
 * @export
 */
export const DairyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DairyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [regionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllDairies(
      regionId?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DataListDairyDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDairies(
        regionId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDairy(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataDairyDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDairy(
        id,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DairyApi - factory interface
 * @export
 */
export const DairyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DairyApiFp(configuration);
  return {
    /**
     *
     * @param {string} [regionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllDairies(
      regionId?: string,
      options?: any
    ): AxiosPromise<DataListDairyDto> {
      return localVarFp
        .getAllDairies(regionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDairy(id: string, options?: any): AxiosPromise<DataDairyDto> {
      return localVarFp
        .getDairy(id, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for getAllDairies operation in DairyApi.
 * @export
 * @interface DairyApiGetAllDairiesRequest
 */
export interface DairyApiGetAllDairiesRequest {
  /**
   *
   * @type {string}
   * @memberof DairyApiGetAllDairies
   */
  readonly regionId?: string;
}

/**
 * Request parameters for getDairy operation in DairyApi.
 * @export
 * @interface DairyApiGetDairyRequest
 */
export interface DairyApiGetDairyRequest {
  /**
   *
   * @type {string}
   * @memberof DairyApiGetDairy
   */
  readonly id: string;
}

/**
 * DairyApi - object-oriented interface
 * @export
 * @class DairyApi
 * @extends {BaseAPI}
 */
export class DairyApi extends BaseAPI {
  /**
   *
   * @param {DairyApiGetAllDairiesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DairyApi
   */
  public getAllDairies(
    requestParameters: DairyApiGetAllDairiesRequest = {},
    options?: AxiosRequestConfig
  ) {
    return DairyApiFp(this.configuration)
      .getAllDairies(requestParameters.regionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DairyApiGetDairyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DairyApi
   */
  public getDairy(
    requestParameters: DairyApiGetDairyRequest,
    options?: AxiosRequestConfig
  ) {
    return DairyApiFp(this.configuration)
      .getDairy(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
